'use strict';

module.exports = Odigeo.Widget.extend({
    modelClass: require('../modules/models/accommodation_filters_summary'),
    viewClass: require('../modules/views/accommodation_filters_summary'),
    update: function() {
        this.model.update.apply(this.model, arguments);
    },
    clearActivatedTags: function() {
        this.model.unset('activatedTags', {silent: true});
    },
    clear: function() {
        this.model.clear();
    },
    loadSummary: function(isLoading) {
        this.view.loadSummary(isLoading);
    },
});
